/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { IRootState } from "@/store/modules/root/state";
import { CommitOptions, DispatchOptions, Module } from "vuex";
import { state, IInboxState } from "./state";
import { getters, IGetters } from "./getters";
import { IMutations, mutations } from "./mutations";
import { actions, IActions } from "./actions";
import { Store as VuexStore } from "vuex";

// Module
export const inbox: Module<IInboxState, IRootState> = {
  state,
  getters,
  mutations,
  actions,
};

// Store type
export type InboxStoreModuleTypes<S = IInboxState> = Omit<
  VuexStore<S>,
  "commit" | "getters" | "dispatch"
> & {
  commit<K extends keyof IMutations, P extends Parameters<IMutations[K]>[1]>(
    key: K,
    payload?: P,
    options?: CommitOptions
  ): ReturnType<IMutations[K]>;
} & {
  getters: {
    [K in keyof IGetters]: ReturnType<IGetters[K]>;
  };
} & {
  dispatch<K extends keyof IActions>(
    key: K,
    payload?: Parameters<IActions[K]>[1],
    options?: DispatchOptions
  ): ReturnType<IActions[K]>;
};
